module.exports = __webpack_public_path__ + "static/media/b-sci-major-43_LR.96c8255f.jpg";